import { passwordRegex } from 'constants/regex';
import { t } from 'i18next';
import * as Yup from 'yup';

export const changePasswordValidationSchema = Yup.object({
  password: Yup.string().required(() => t('required')).matches(passwordRegex, () => t('passwordError')),
  newPassword: Yup.string().required(() => t('required')).matches(passwordRegex, () => t('passwordError')),
  confirmNewPassword: Yup.string()
    .required(() => t('required'))
    .matches(passwordRegex, () => t('passwordError'))
    .oneOf([Yup.ref('newPassword')], () => t('passwordsDoNotMatch')),
});
